import React, { useState } from "react";

import InspectionRow from "./InspectionRow.js";

import { Box, Column, Columns, Pagination, Select, Tabs } from "@allxsmith/bestax-bulma";
import {createSetDataFreshAction, createSetInspectionDataAction} from "../../actions/dataActions";
import {getDataFresh, getDepartmentsData, getInspectionData, getInspectionTypesData} from "../../state/selectors";
import { useInspectionData } from "../../hooks/useInspectionData";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-spinner-material";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";
import axios from "axios";
import { formatDate, readableDate } from "../../utils";
import SearchBar from "../Utils/SearchBar";
import CreateJobModal from "./CreateJobModal";
import {useInspectionTypeData} from "../../hooks/useInspectionTypeData";
import useSelect from "../../hooks/useSelect";
import InspectionCountModal from "./InspectionCountModal";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import DepartmentPicker from "../Job/DepartmentPicker";
import Nav from "../Nav/Nav";
import LoadingSpinner from "../Utils/Spinner";
import {toast, ToastContainer} from "react-toastify";
import PaginationWrapper from "../Utils/PaginationWrapper";

export default function Inspection(props) {
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const dataFresh = useSelector(getDataFresh);
  const [filters, setFilters] = useState({});
  const [searchText, setSearchText] = useState("");
  const [currentSearch, setCurrentSearch] = useState("");
  const [activeTab, setTab] = useState("all");
  const [activeView, setView] = useState("other");
  const [searchFresh, setSearchFresh] = useState(1);
  const [jobModalOpen, setJobModalOpen] = useState(false);
  const [jobData, setJobData] = useState({});
  const [inspectionCount, setInspectionCount] = useState(0);
  const [countModal, setCountModal] = useState(false);
  const [dayFilter, setDayFilter] = useState("all");
  const [selectedDepartment, setSelectedDepartment] = useState();

  const [showToday, setShowToday] = useState(false);
  const [showTomorrow, setShowTomorrow] = useState(false);
  const [show2Days, setShow2Days] = useState(false);
  let params = { page };

  if (currentSearch) {
    params.search = currentSearch;
  }
  if(dayFilter){
    params.day = dayFilter
  }
  if(selectedDepartment){
    params.department = selectedDepartment
  }

  if(showToday){
    params.showToday = showToday
  }
  if(showTomorrow){
    params.showTomorrow = showTomorrow
  }
  if(show2Days){
    params.show2Days = show2Days
  }
  if (activeView){
    params.type = activeView
  }
  if (searchFresh){
    params.searchFresh = searchFresh;
  }
  if(activeTab){
    params.view = activeTab;
  }
  for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter]) {
      params[filter] = filters[filter][0][filter];
    }
  }

  const complete = useInspectionData(params, dataFresh);
  const departmentsLoaded = useDepartmentsData({}, dataFresh);
  let data = useSelector(getInspectionData);
  let departments = useSelector(getDepartmentsData);

  const onInspectionUpdate = (index, newInspection) => {
    let newResults = [...data.results]
    let newState = { ...data, results: newResults };

    newState.results[index] = newInspection;
    dispatch(createSetInspectionDataAction(newState));
  };
  const onDepartmentChange = e => {
    setSelectedDepartment(e.target.value)
  }

  const handleSearch = () => {
    setPage(1);
    setCurrentSearch(searchText);
    setSearchFresh(searchFresh+1);
  };

  const getInspectionCount = (data, date) => {
    const conf = {
      url: props.endpoint+"inspectioncount?type="+data.inspection_type+"&date="+date,
      method: "get"
    }
    axios(conf).then(res => {
      setInspectionCount(res.data);
      setCountModal(true);
    })
  }


  const setNewTab = (tab) => {
    setPage(1);
    setTab(tab);
  };

  const setType = (e) => {
    setPage(1);
    setView(e.target.value)
  }
  const setNewView = (view) => {
    setDayFilter(view);
  };

  const clear = () => {
    setSearchText("");
    setCurrentSearch("");
    setPage(1);
  };

  const onInspectionApprove = (e, inspection, setEditable) => {
    e.stopPropagation();
    if (inspection.new_completed_date && inspection.new_expiry_date) {
      let inspectionToSave = { ...inspection };
      inspectionToSave.vehicle = inspection.vehicle.id;
      const url = props.endpoint + "inspections/approve/";
      const conf = {
        method: "put",
        data: inspectionToSave,
        url
      };
      axios(conf).then(() => {
        setEditable(false);
        dispatch(createSetDataFreshAction(dataFresh + 1));
      });
    } else {
      toast.warning(
        "You must specify a new expiry and completion date before appriving!", {position: "top-right"}
      );
    }
  };

  const headings = [
    {
      label: "Fleet Number"
    },
    {
      label: "Registration",
      field: "vehicle__registration",
      labelField: "vehicle__registration"
    },
    {
      label: "Vehicle Location",
      field: "vehicle__location",
      labelField: "vehicle__location"
    },
    {
      label: "Type",
      field: "inspection_type",
      labelField: "inspection_type"
    },
    {
      label: "Workshop",
      field: "inspection_workshop",
      labelField: "inspection_workshop__display_name"
    },
    {
      label: "Hire Customer",
      field: "vehicle__hire_customer",
      labelField: "vehicle__hire_customer__display_name"
    },
    {
      label: "Expiry Date",
      field: "expiry_date",
      labelField: "expiry_date",
      date: true
    },
    {
      label: "Last Completed",
      field: "date_completed",
      labelField: "date_completed",
      date: true
    },
    {
      label: "Comments"
    },
    {
      label: "Book In Date",
      field: "booked_in_date",
      labelField: "booked_in_date",
      date: true
    },
    {
      label: "New Completed Date",
      field: "new_completed_date",
      labelField: "new_completed_date",
      date: true
    },
    {
      label: "New Expiry Date",
      field: "new_expiry_date",
      labelField: "new_expiry_date",
      date: true
    },
    {
      label: "Vehicle Arrived"
    }
  ];

  if (!complete || !departmentsLoaded) {
    return (
        <div>
          <Nav/>
          <LoadingSpinner/>
        </div>
    );
  }

  document.title = "Inspections";

  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  return (
    <div>
      <Nav/>
      <br/>
      <br/>
      <Box>
        <h1 className="title">Inspections</h1>
        <Columns isMultiline>
          <Column size={4}>
            <label className="label">Search</label>
            <SearchBar
              handleSearch={handleSearch}
              setSearchText={setSearchText}
              searchText={searchText}
              clear={clear}
            />
          </Column>
          <Column>
            <DepartmentPicker
              departments={departments}
              selectedDepartment={selectedDepartment}
              onDepartmentChange={onDepartmentChange}
            />
          </Column>
        </Columns>
      </Box>
      <Box>
        <Columns isMultiline>
          <Column>
            <h1 className="title">Upcoming Inspections</h1>
          </Column>
        </Columns>
        <Columns isMultiline />
        <Columns isMultiline>
          <Column>
            <label className="label"></label>
            <Tabs align="left" toggle>
              <Tabs.List>
                <Tabs.Item active={activeTab === "all"}><a onClick={() => setNewTab("all")}>All
                                </a></Tabs.Item>
                <Tabs.Item active={activeTab === "fleet"}><a onClick={() => setNewTab("fleet")}>Fleet
                                </a></Tabs.Item>
                <Tabs.Item active={activeTab === "customer"}><a onClick={() => setNewTab("customer")}>Customer
                                </a></Tabs.Item>
              </Tabs.List>
            </Tabs>
          </Column>
          <Column>
            <label className="label"></label>
            <Tabs align="left" toggle>
              <Tabs.List>
                <Tabs.Item active={dayFilter === "none"}><a onClick={() => setNewView("none")}>All
                                </a></Tabs.Item>
                <Tabs.Item active={dayFilter === "all"}><a onClick={() => setNewView("all")}>All Upcoming
                                </a></Tabs.Item>
                <Tabs.Item active={dayFilter === "2daysago"}><a onClick={() => setNewView("2daysago")}>2 Days Ago
                                </a></Tabs.Item>
                <Tabs.Item active={dayFilter === "yesterday"}><a onClick={() => setNewView("yesterday")}>Yesterday
                                </a></Tabs.Item>
                <Tabs.Item active={dayFilter === "today"}><a onClick={() => setNewView("today")}>Today
                                </a></Tabs.Item>
                <Tabs.Item active={dayFilter === "tomorrow"}><a onClick={() => setNewView("tomorrow")}>Tomorrow
                                </a></Tabs.Item>
                <Tabs.Item active={dayFilter === "2days"}><a onClick={() => setNewView("2days")}>2 Days From Today
                                </a></Tabs.Item>
                <Tabs.Item active={dayFilter === "booked"}><a onClick={() => setNewView("booked")}>Booked
                                </a></Tabs.Item>
                <Tabs.Item active={dayFilter === "need_approval"}><a onClick={() => setNewView("need_approval")}>Need Approval
                                </a></Tabs.Item>
              </Tabs.List>
            </Tabs>
          </Column>
          <Column>
            <label className="label">Inspection Type</label>
            <Select
              onChange={setType}
              value={activeView}
            >
              <option key={"other"} value={"other"}>Other</option>
              <option key={"road"} value={"road"}>Road Tax</option>
            </Select>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <table className="table is-hoverable is-fullwidth is-striped">
              <thead>
                <tr>
                  {headings.map(heading => {
                    if (!heading.field) {
                      return <th key={heading.label}>{heading.label}</th>;
                    }
                    if (heading.blank) {
                      return (
                        <FilterBlankHeading
                          key={heading.label}
                          heading={heading}
                          setFilters={f => {
                            setPage(1);
                            setFilters(f);
                          }}
                          filters={filters}
                        />
                      );
                    }
                    return (
                      <FilterHeading
                        key={heading.label}
                        heading={heading}
                        setFilters={f => {
                          setPage(1);
                          setFilters(f);
                        }}
                        filters={filters}
                        options={(data && data.filter_list) && data.filter_list[heading.field]}
                      />
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {(data && data.results) && data.results.map((value, index) => (
                  <InspectionRow
                    key={value.id}
                    inspection={value}
                    index={index}
                    onInspectionUpdate={onInspectionUpdate}
                    endpoint={props.endpoint}
                    setJobModalOpen={setJobModalOpen}
                    setJobData={setJobData}
                    getCount={getInspectionCount}
                    onInspectionApprove={onInspectionApprove}
                  />
                ))}
              </tbody>
            </table>
            <PaginationWrapper
              setPage={setPage}
              page={page}
              dataCount={data ? Math.ceil(data.count / 25) : 0}
            />
            </Column>
        </Columns>
      </Box>
      {inspectionCount !== 0 &&
        <InspectionCountModal
          count={inspectionCount}
          open={countModal}
          setOpen={setCountModal}
          onCancel={() => setCountModal(false)}
        />
      }
      {jobData.inspection &&
      <CreateJobModal
        endpoint={props.endpoint}
        open={jobModalOpen}
        setOpen={setJobModalOpen}
        data={jobData}
        setData={setJobData}
      />
      }
    </div>
  );
}
